import React from "react";

const Contact = () => (
  <section className="contact" id="contact">
    <div className="contact-content">
      <h2>Need a Workforce fast?</h2>
      <a href="tel:+918956619631" className="contact-btn">
        Call Us +91 89566 19631
      </a>
    </div>
  </section>
);

export default Contact; 